var React = require('react');
var ReactIntl = require('react-intl');
var IntlProvider = ReactIntl.IntlProvider;
var injectIntl = ReactIntl.injectIntl;
var createReactClass = require('create-react-class');
var LoginPreferencesNavigationMenu = require('./LoginPreferencesNavigationMenu.js');
var PageCase = require('../PageCase/PageCase.js');
var Header = require('../Header/Header');
const FooterMinimal = require('../Footer/FooterMinimal');
var LoginPreferencesWrapper = require('./LoginPreferencesWrapper');
var LoginPreferencesMobileView = require('./LoginPreferencesMobileView.js');
var LoginStore = require('../../stores/LoginStore');
var LoginActions = require('../../actions/LoginActions');
var { Session } = require('../../LPAuthUtils/SessionMonitor.js');
var OAuthClientConfig = require('../../LPAuthUtils/OAuthClientConfig');
var { clearLocalStorage, generateLogoutUrl } = require('../../LPAuthUtils/AuthUtil');
require('./login-preferences.less');
var SetLoginPreferences = createReactClass({
    displayName: 'SetLoginPreferences',

    getInitialState() {
        return {
            localeId: this.props.localeId,
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            userId: '',
            userDetails: {},
            upn: ''
        };
    },

    componentDidMount: function () {
        LoginActions.getUserDetails(this.props.idToken, this.props.userType);
        LoginStore.addGetUserDetailsReceivedListener(this._onGetUserDetails);
    },

    getUserDetails: function () {
        LoginActions.getUserDetails(this.props.idToken, this.props.userType);
    },

    componentWillUnmount: function () {
        LoginStore.removeGetUserDetailsReceivedListener(this._onGetUserDetails);
    },

    _onGetUserDetails: function () {
        let appState = LoginStore.getState();

        if (appState.userDetails) {
            const userAuthMethod = appState.userDetails.userLoginDetails.authenticationMethod;
            const { userId } = appState.userDetails.userBasicDetails;
            const upn = appState.userDetails.userLoginDetails.userPrincipalName;
            this.setState({ userAuthenticationMethod: userAuthMethod, userId , upn});
        }
    },

    onLogoutClick() {
        Session.destroy('sessionLP');

        const idamClient = OAuthClientConfig;
        generateLogoutUrl(idamClient, this.props.idToken)
            .then((logoutUrl) => {
                clearLocalStorage();
                Session.destroy();
                window.location = logoutUrl;
            });
    },

    renderContent: function () {
        const idToken = this.props.idToken;
        const decodedIdToken = this.props.decodedIdToken || {};
        const name = decodedIdToken.name;
        const email = decodedIdToken.email || this.state.upn;
        const redirectUri = this.props.redirectUrl;
        const userType = this.props.userType;
        return (
            !this.state.isMobile ?
                <LoginPreferencesWrapper>
                    <LoginPreferencesNavigationMenu
                        idToken={idToken}
                        userType={userType}
                        userId={this.state.userId}
                        redirectUri={redirectUri}
                        name={name}
                        email={email}
                        traceId={this.props.traceId}
                        realmId={this.props.realmId}
                        countryCode={this.props.countryCode}
                        localeId={this.props.localeId}
                        decodedIdToken={this.props.decodedIdToken}
                        userAuthenticationMethod={this.state.userAuthenticationMethod}
                        getUserDetails={this.getUserDetails.bind(this)}
                        onLogoutClick={this.onLogoutClick} />
                </LoginPreferencesWrapper> :
                <LoginPreferencesWrapper>
                    <LoginPreferencesMobileView
                        idToken={idToken}
                        userType={userType}
                        redirectUri={redirectUri}
                        name={name}
                        email={email}
                        traceId={this.props.traceId}
                        realmId={this.props.realmId}
                        countryCode={this.props.countryCode}
                        decodedIdToken={this.props.decodedIdToken}
                        userAuthenticationMethod={this.state.userAuthenticationMethod}
                        getUserDetails={this.getUserDetails.bind(this)} 
                        onLogoutClick={this.onLogoutClick}/>
                </LoginPreferencesWrapper>
                
        );
    },

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    },

    renderFooter: function () {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}>
                <div className='fixFooterBottom'>
                    <FooterMinimal {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange} />
                </div>
            </IntlProvider>
        );
    },

    render: function () {
        return (
            <PageCase
                isLoginPreferencesView={true}
                header={<Header />}
                content={this.renderContent()}
                footer={this.renderFooter()}>
            </PageCase>
        );
    }
});

module.exports = injectIntl(SetLoginPreferences);
